import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, Span, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const IncertidumbreTransicion = ({ user, background, number }) => {
  // const iata = (parseFloat(user['IATA']) / 5) * 100;
  const iataContext = (parseFloat(user['IATA_CON']) / 5) * 100;
  // const iataRend = (parseFloat(user['IATA_REN']) / 5) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h1>4. Incertidumbre ante la Transición Académica</h1>
          <p className='justified'>
            Piensa en la incertidumbre como estar en una montaña rusa: es
            emocionante, pero también da un poco de miedo o preocupación, porque
            no sabes qué esperar en la próxima curva. De manera similar, en la
            vida a veces no sabemos qué nos depara el futuro y eso puede generar
            sentimientos de nerviosismo o preocupación.{' '}
            <strong>
              Es normal sentir un poco de ansiedad por los cambios y desafíos
              que se avecinan con el paso a la educación media
            </strong>
            . Sin embargo, es importante identificar si sientes excesiva
            preocupación, para poder trabajar esas emociones y así{' '}
            <strong>
              poder enfrentar la transición académica de forma más segura y
              tranquila
            </strong>
            .
          </p>
          <p className='justified'>
            A continuación, encontrarás tus puntajes en dos áreas clave, de
            acuerdo a tus respuestas al test.
          </p>
          <p className='justified'>
            Resultados en
            <Span strong color={polarColors[0]}>
              {' '}
              ROJO{' '}
            </Span>
            sugieren mayores niveles de preocupación o incertidumbre en el área.
            Resultados en{' '}
            <Span strong color={polarColors[4]}>
              VERDE
            </Span>{' '}
            sugieren bajos niveles o ausencia de incertidumbre ante la
            transición en el área.
          </p>
          <br />
          <h2>4.1. Contexto Académico</h2>
          <p className='justified'>
            Este puntaje refleja tu nivel de preocupación ante los cambios en el
            entorno escolar, como pueden ser por ejemplo nuevos profesores,
            cambios de salas, de horarios, o nuevas formas de estudiar y
            trabajar:
          </p>
          <div className='progress-info-group' style={{ marginTop: 36 }}>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={iataContext}
                  backColor={() => getColor(iataContext)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{iataContext.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
          {/* <h2>3.2. Rendimiento y futuro</h2>
          <p className='justified'>
            Este puntaje muestra tu nivel de preocupación ante las mayores
            demandas académicas que puede implicar el paso a educación media
            (por mayor dificultad, mayor exigencia o mayor importancia de las
            notas en esta etapa), así como por tener que comenzar a decidir
            sobre lo que harás al terminar el colegio:
          </p>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={iataRend}
                  backColor={() => getColor(iataRend)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{iataRend.toFixed(0)}</ProgressStat>
              </div>
            </div>
          </div>
          <p className='justified'>
            Recuerda que es normal sentirte un poco nervioso/a en la nueva etapa
            que se inicia, esto puede ser señal de que tu mente está activa y
            comprometida con tu crecimiento y desarrollo. Lo importante es
            aprender a manejar estos sentimientos de manera constructiva,
            especialmente si alcanzaste puntajes más altos. Para esto, es
            importante tomarse un tiempo para reflexionar sobre lo que te
            preocupa y por qué. También, compartir tus preocupaciones con
            amigos/as y familiares puede aliviar su peso y ayudarte a encontrar
            soluciones, así como hablar con tus profesores u orientador/a, ellos
            pueden ayudarte y ofrecerte orientación personalizada.
          </p> */}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default IncertidumbreTransicion;
